import styled from 'styled-components/macro';

export const Container = styled.div`
  max-width: 673px;
  width: 100%;
  padding-top: 32px;
  padding-bottom: 64px;
`;
